import { useEffect } from 'react';

function SmoothScroll() {
  useEffect(() => {
    const handleClick = (e) => {
      const href = e.target.getAttribute('href');

      if (href && href.startsWith('#')) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          // Scroll mais lento usando animação customizada
          const startPosition = window.pageYOffset;
          const targetPosition = targetElement.offsetTop - 80; // offset para o navbar
          const distance = targetPosition - startPosition;
          const duration = 1200; // duração em ms (mais lento)
          let start = null;

          const animation = (currentTime) => {
            if (start === null) start = currentTime;
            const timeElapsed = currentTime - start;
            const run = ease(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
          };

          // Função de easing para suavizar a animação
          const ease = (t, b, c, d) => {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
          };

          requestAnimationFrame(animation);
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
}

export default SmoothScroll;
